/**
 * RentLow Application Build & Version Tracker
 * This updates automatically with each build and deployment to verify live deployment status.
 */
export const APP_VERSION_INFO = {
  version: "v3.4.0",
  buildDate: "23 Oct 2026",
  buildTime: "09:12 IST",
  channel: "Live Production (RentLow.co.in)",
  commitTag: "rev-2026.10.23-v3.4.0-return-policy-verified",
};
